/**
 * DermaPatch Landing V2 — scroll-reveal progressive enhancement.
 * Sin esto, todo el contenido es visible desde el inicio (el estado oculto
 * solo se activa vía la clase que este script agrega a <html>), así que un
 * fallo de carga del script nunca deja secciones invisibles.
 *
 * Candidato a promoverse a componente del Sistema Mejoris si una segunda
 * landing lo necesita — ver informe del Sprint.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  document.documentElement.classList.add('dp-reveal-active');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dp-revealed');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) { io.observe(el); });
})();
